<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="top_tance"></div>
    <div class="paddingContent">
      <div class="btn addBtn fr" @click="$router.push('/addSpecialEdition')">新增專輯</div>
      <div class="tableWrap">
        <el-table height='660px' stripe :data="speList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in speListTable" :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop]&& scope.row[item.prop]!==0">-</div>
              <div class="mainImgWrap normal_font" v-else-if="item.prop === 'albumCoverWeb'" >
                <img class="mainImg" :src="scope.row.albumCoverWeb" alt="">
                <p v-show="scope.row.albumCoverWeb !== '' && scope.row.albumCoverWeb !== null"
                   @click="previewImg(scope.row.albumCoverWeb)">查看</p>
              </div>
              <div v-else>{{scope.row[item.prop]}}</div> 
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click="toEdit(scope.row.id)" type="text">修改</el-button>
              <el-button @click="delAlbum(scope.row.id)" type="text">刪除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
                       hide-on-single-page
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-size="10"
                       :pager-count='5'
                       layout="prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
    <div v-if="imgProp" class="propWrap">
      <div class="prop-content mobile_show">
        <i class="iconfont icon-close fr hand" @click="closeProp"></i>
        <p class="prop-title normal_font">查看圖片預覽</p>
        <img class="previewImg" :src="previewImgUrl" alt="">
        <div class="bottomBtn">
          <!--<div class="btn">取消</div>-->
          <div class="btn hand new_btn" @click="closeProp">確認</div>
        </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';

export default {
  data() {
    return {
      navBlock: '專輯',
      navtitle: '專輯列表',
      speList: [],
      speListTable: [
        {
          prop: 'id',
          label: '專輯id',
          width: ''
        }, {
          prop: 'album',
          label: '專輯名稱',
          width: ''
        }, {
          prop: 'albumCoverWeb',
          label: '專輯主圖',
          width: ''
        }, {
          prop: 'releaseDate',
          label: '發行時間',
          width: '150'
        }, {
          prop: 'sequence',
          label: '排序',
          width: '60'
        }
      ],
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
      imgProp:false
    }
  },
  created() {
    let _this = this;
    _this.getSpecialEditionList();
  },
  activated() {
    let _this = this;
    _this.getSpecialEditionList();
    // if (_this.currentPage === 1) {
    //   _this.getSpecialEditionList();
    // }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    getSpecialEditionList() {
      let _this = this;
      let param = {
        pageNo: _this.currentPage,
        pageSize: 10
      }
      _this.$post('/request/album/findAllAlbum', param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            res.data.albumDtoList.forEach(v => {
              v.releaseDate = v.releaseDate.substring(0, 7);
            });
            _this.speList = res.data.albumDtoList;
            _this.total = res.data.total;
          } else {
            _this.$propMessage(res.message);
          }
        });
    },

    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getSpecialEditionList();
    },

    // 删除专辑
    delAlbum(id) {
      let _this = this;
      _this.$confirm('是否刪除該專輯?', '提示信息', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        center: true,
        closeOnClickModal: false
      }).then(() => {
        // 确认删除的回调
        _this.$get(`/request/album/deleteAlbum/${id}`, {}, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === '00000') {
              _this.$propMessage('刪除成功', 'success',
                function () {
                  _this.dialogVisible = false;
                  _this.currentPage = 1;
                  _this.getSpecialEditionList();
                });
            } else {
              _this.$propMessage(res.message, 'error',
                function () {
                  _this.dialogVisible = false;
                });
            }
            ;
          });
      });
    },


    toEdit(id) {
      this.$router.push(`/editSpecialEdition?id=${id}`);
    },
    closeProp() {
      this.imgProp = false;
    },
    previewImg(url) {
      this.imgProp = true;
      this.previewImgUrl = url;
    },
  },
  components: {
    NavBar,
    DiaMess,

  }
};
</script>

<style lang="less" scoped>
.content {
  .mainImgWrap {
    display: flex;
    justify-content: center;
    align-items: center;

    .mainImg {
      max-height: 0.6rem;
      max-width: 0.6rem;
      border-radius: 0.05rem;
    }

    p {
      min-width: 0.6rem;
      padding-left: 0.1rem;
      color: @mainColor;
      cursor: pointer;
      white-space: nowrap;
    }
  }
  .previewImg {
    width: 7rem;
    display: block;
    padding: 0.2rem 0 0.3rem 0;
    margin: 0 auto;
  }
  .propWrap {
    .prop-content {
      // height: 90%;
      overflow: auto;

      img {
        // width: 38%;
        width: 70%;
        // max-height:5rem;
        // max-height:76%;
        @media (max-width: 420px) {
          width: 50%;
        }

      }
    }
  }
  .top_tance {
    padding-top: 0.8rem;

    @media (max-width: 768px) {
      padding-top: 22px;
    }

    @media (max-width: 420px) {
      padding-top: 62px;
    }

  }

  .paddingContent {
    height: calc(100% - 88px);
    padding: 0 0.4rem;
    background-color: #ffffff;

    @media (max-width: 768px) {
      height: calc(100% - 62px);
    }

    .addBtn {
      margin: 0.2rem 0;
      cursor: pointer;

      @media (max-width: 420px) {
        margin-top: 0.3rem;
        margin-bottom: 10px;
      }

    }

    .btn {
      @media (max-width: 420px) {
        width: 1.3rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 12px;
      }
    }

    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }

    }

    .el-table {
      @media (max-width: 420px) {
        min-width: 200%;
      }
    }

  }

  .paging-block {
    margin: 0.2rem 0;

    @media (max-width: 420px) {
      margin: 0.3rem 0;
    }

  }

  .label_num {
    font-size: 14px;
    line-height: 32px;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/specialEdition/specialEditionList.vue